<template>
  <div class="bg-color">
    <Navbar />
    <Header
      :category="'press'"
      :bannerTitle="bannerTitle"
      :breadCrumb="breadCrumb"
    />
    <NewsDetailBody />
    <FooterTop />
    <FooterBottom />
  </div>
</template>

<script>
import Navbar from "components/DefaultHome/KECC/Common/NavbarStyle";
import Header from "components/DefaultHome/KECC/Common/Header";
import NewsDetailBody from "./NewsDetailBody";
import FooterTop from "components/DefaultHome/KECC/Common/FooterTop?v=1.0";
import FooterBottom from "components/DefaultHome/KECC/Common/BacktopButton";

export default {
  name: "NewsDetailMain",
  components: {
    Navbar,
    Header,
    NewsDetailBody,
    FooterTop,
    FooterBottom,
  },
  data() {
    return {
      bannerTitle: "press",
      breadCrumb: [
        {
          name: this.$t("navbar.menu_3_1"),
          path: "/news",
        },
      ],
    };
  },
};
</script>

<style>
.bg-color {
  background-color: #eff4f5;
}
</style>
